import React, { useState } from "react";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import SmartToyOutlinedIcon from "@mui/icons-material/SmartToyOutlined";
import ChatPanel from "./ChatPanel";

const ChatBot = () => {
    const [open, setOpen] = useState(false);

    return (
        <>
            <Tooltip title="yai4ottoman AI Assistant" arrow placement="bottom">
               <IconButton
                    size="small"
                    onClick={() => setOpen((prev) => !prev)}
                   sx={{
                        width: 36,
                        height: 36,
                        borderRadius: "50%",
                        backgroundColor: open ? "#25ebd1ff" : "#3bf6f6ff",
                        transition: "background-color 0.2s, transform 0.2s",
                        "&:hover": {
                            backgroundColor: "#25eb50ff",
                            transform: "scale(1.08)",
                        },
                        "& .MuiSvgIcon-root": {
                            color: "white",
                        },
                    }}
                >
                    <SmartToyOutlinedIcon fontSize="small" />
                </IconButton>
            </Tooltip>

            {open && <ChatPanel onClose={() => setOpen(false)} />}
        </>
    );
};

export default ChatBot;